var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analyses-container"},[(_vm.analysis)?_c('analyses-controller',{key:_vm.uuid,attrs:{"source":_vm.source}}):_c('agro-interative-loading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }